module.exports = __webpack_public_path__ + "7693aa7b2bf2d19556249ae390dcaa57.jpg";